module.exports = __webpack_public_path__ + "static/map-944a4bc6aaf83195c1e00452928c786d.jpg";